import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[leapControlErrorContainer]'
})
export class ControlErrorContainerDirective {

  constructor(public vcr: ViewContainerRef) { }
}
